import { MobXProviderContext } from 'mobx-react';
import React from 'react';
import type { RootStoreProps } from 'Stores/RootStore.types';
import { UseConversationHasMessagesResult } from './index.types';

/**
 * Reports whether a conversation has messages in the message store.
 *
 * Ignores conversation.lastMessageId, which can remain set after a
 * conversation's history is deleted.
 *
 * Load messages first before relying on hasMessages to distinguish an
 * empty conversation from one that simply hasn't loaded yet.
 *
 * @param conversationId - Conversation to inspect, or null/undefined when none is selected
 */
export const useConversationHasMessages = (
  conversationId?: string | null
): UseConversationHasMessagesResult => {
  const { message } = React.useContext<RootStoreProps>(MobXProviderContext);

  const container = conversationId
    ? message.selectGroupedMessagesForConversation(conversationId)
    : null;

  const totalCount = container?.TotalMessageCount ?? 0;

  return {
    hasMessages: totalCount > 0,
    totalCount,
  };
};
